import {
  ArrowRight,
  BarChart3,
  Bookmark,
  Calculator,
  CheckCircle2,
  Clock,
  PenTool,
  Search,
  TrendingUp,
} from "lucide-react";
import { Testimonial } from "@/components/ui/testimonial-card";
import { Header } from "@/components/Header";

const testimonials = [
  {
    name: "Alex Chen",
    role: "Perfect Score Student",
    company: "Scholar Sphere",
    rating: 5,
    image: "https://www.shadcnblocks.com/images/block/avatar-1.webp",
    testimonial:
      "The detailed analytics and instant feedback made it easy to spot weak areas and improve quickly.",
  },
  {
    name: "Sarah Johnson",
    role: "SAT Strategist",
    company: "Scholar Sphere",
    rating: 5,
    image: "https://www.shadcnblocks.com/images/block/avatar-2.webp",
    testimonial:
      "Annotations, timers, and the Desmos calculator feel seamless—it's the closest thing to real test-day practice.",
  },
  {
    name: "Michael Park",
    role: "Tutor",
    company: "Scholar Sphere",
    rating: 5,
    image: "https://www.shadcnblocks.com/images/block/avatar-3.webp",
    testimonial:
      "My students love the gamified progress tracking. The question bank stats keep everyone accountable.",
  },
];

const features = [
  { icon: ArrowRight, label: "Seamless Question Navigation" },
  { icon: Calculator, label: "Built-in Desmos Calculator" },
  { icon: PenTool, label: "Text Annotation (like Bluebook)" },
  { icon: CheckCircle2, label: "Instant Feedback" },
  { icon: Clock, label: "Per Question Timer" },
  { icon: Bookmark, label: "Bookmark Questions" },
  { icon: Search, label: "Advanced Filtering" },
  { icon: BarChart3, label: "Track Progress with Charts" },
  { icon: TrendingUp, label: "Advanced Question Bank Stats*" },
];

interface FeaturesPageProps {
  showOnlyReviews?: boolean;
}

export function FeaturesPage({ showOnlyReviews = false }: FeaturesPageProps) {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="px-8 pb-20">
        {!showOnlyReviews && (
          <section className="max-w-5xl mx-auto py-12">
            <h1 className="text-4xl font-bold text-center mb-12">Features</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map(({ icon: Icon, label }) => (
                <div
                  key={label}
                  className="flex items-center gap-4 p-4 rounded-3xl bg-muted/50"
                >
                  <Icon className="size-6 shrink-0 text-foreground" />
                  <span className="text-foreground font-medium">{label}</span>
                </div>
              ))}
            </div>
          </section>
        )}

        <section id="reviews" className="max-w-5xl mx-auto py-12">
          <div className="flex flex-col items-center text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Don't believe us</h2>
            <p className="text-2xl text-muted-foreground">
              believe our customers...
            </p>
          </div>
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {testimonials.map((testimonial) => (
              <Testimonial key={testimonial.name} {...testimonial} />
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}






